module.exports = __webpack_public_path__ + "img/xinnengyuan.db5293a0.png";